import React, { useContext, useEffect, useState } from "react";
import STC from "../../../../STCLibrary/STCFactory/STCFactory";
import MaintenanceNotice from "../../MaintenanceNotice/MaintenanceNotice";
import { MaintenanceAPIs } from "../../../../API/MaintenanceAPIs/MaintenanceAPIs";
import ApiResponseHandler from "../../../../STCLibrary/ApiResponseHandler/ApiResponseHandler";
import NotificationContext from "../../../../STCLibrary/NotificationSystem/NotificationContext";
import { useNavigate } from "react-router-dom";


export default function AdminDashboard(){

    const notificationCtx = useContext(NotificationContext);
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [sending, setSending] = useState(false);
    const [maintenance, setMaintenance] = useState(false);
    const [mainText, setMainText] = useState('');
    const [subText, setSubText] = useState('');
    const [maintenanceData, setMaintenanceData] = useState(null);




    const getMaintenanceStatus = async () => {
        //Fetch details from DB
        try{
            const response = (await MaintenanceAPIs.GetMaintenanceMode()).data;
            console.log(response);
            setMaintenanceData(response.data);
           
        }
        catch (err){
            console.log(err);
            // ApiResponseHandler(err.response, notificationCtx, navigate);
        }
        finally{
            setLoading(false);
        }
    }

    const handleUpdateCheckbox = (status) => {

        if(!window.confirm(`Are you sure you want to turn ${status ? 'On' : 'Off'} maintenance mode?`)){
            return
        }
        setMaintenance(status);
    }

    const updateField = (field, value) => {

        const temp = {...maintenanceData};
        temp[field] = value;
        setMaintenanceData(temp);
    }

    const updateMaintenanceStatus = async () => {
        //Update boolean and message
        try{
            setSending(true)
            const putJSON = {
                id: 1,
                main_text: maintenanceData.main_text,
                secondary_text: maintenanceData.secondary_text,
                status: maintenanceData.status,
            }
            const response = (await MaintenanceAPIs.PutMaintenanceMode(putJSON)).data;
            console.log('Update response:', response);

            const handlerResponse = {
                status: response.message === "Maintenance mode updated successfully" ? 200 : 204,
                data: '',
                statusText: "Maintenance mode updated successfully" ? "OK" : 'No Content'
            }
            ApiResponseHandler(handlerResponse, notificationCtx, navigate);
            await getMaintenanceStatus();
        }
        catch (err){
            console.log(err);
            ApiResponseHandler(err.response, notificationCtx, navigate);
        }
        finally{
            setLoading(false);
            setSending(false);
        }
    }


    const handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('Submitted');
        updateMaintenanceStatus();
    }

    useEffect(() => {
        getMaintenanceStatus();
    }, [])

    if(loading){
        return(
            <div>Loading...</div>
        )
    }
    else{
        return(
            <div className="p-2">
                <div className="m-2 p-4" style={{border: '2px solid blue', borderRadius: '1rem', backgroundColor: 'white'}}>
                    <div><strong>Maintenance Mode: </strong> <STC.Form.Check checked={maintenanceData.status} onChange={(e) => updateField('status', e.target.checked ? 1 : 0)}/></div>

                    <STC.Form onSubmit={handleSubmit}>
                    <div>
                        <strong>Header Message</strong>
                        <div>
                            <STC.Form.Control as='textarea' rows={3} value={maintenanceData.main_text} onChange={(e) => updateField('main_text', e.target.value)}/>
                        </div>
                    </div>

                    <div>
                        <strong>Secondary Message</strong>
                        <div>
                            <STC.Form.Control as='textarea' rows={2} value={maintenanceData.secondary_text} onChange={(e) => updateField('secondary_text', e.target.value)}/>
                        </div>
                    </div>

                    <div align='end' className="mt-2">
                        <STC.Button type='submit' disabled={sending}>Save</STC.Button>
                    </div>
                    </STC.Form>
                </div>

                <div  className="m-2 p-4" style={{border: '2px solid blue', borderRadius: '1rem', backgroundColor: 'white'}}>
                    <h3>Preview:</h3>
                    <div>
                        <MaintenanceNotice maintenanceData={maintenanceData} />
                    </div>
                </div>
            </div>
        )
    }
    
}